export default "__VITE_ASSET__DBBdnJxr__"